import moment from "moment";
import Vue from "vue";
import MasterService from "@/services/MasterService";
import store from "@/store";

const state = {
  finalImagePath: null,
  finalHeight:null,
  finalWidth:null,
};

const mutations = {
  SET_FINAL_IMAGE_PATH: (state, path) => {
    state.finalImagePath = path;
    console.log("state.finalImagePath :>> ", state.finalImagePath);
  },
  SET_FINAL_HEIGHT_WIDTH_PATH: (state, path) => {
    state.finalHeight = path.finalHeight;
    state.finalWidth = path.finalWidth;
    console.log("state.FinalHeightWidth :>> ", path);
  }
};

const actions = {
  setFinalImagePath: ({ state, commit, dispatch }, payload) => {
    commit("SET_FINAL_IMAGE_PATH", "");
    if(payload.hasOwnProperty("finalHeight")){
      commit("SET_FINAL_HEIGHT_WIDTH_PATH", {finalHeight:"",finalWidth:""});
    }
   
    Vue.nextTick(() => {
      commit("SET_FINAL_IMAGE_PATH", payload.path);
      if(payload.hasOwnProperty("finalHeight")){
        commit("SET_FINAL_HEIGHT_WIDTH_PATH", {finalHeight:payload.finalHeight,finalWidth:payload.finalWidth});
      }
    });
    if (payload.flag == 2) {
      vmVue.$root.$emit("bv::hide::modal", "galleryModal");
    }
  }
};

const getters = {
  finalImagePath: state => state.finalImagePath,
  finalHeight: state => state.finalHeight,
  finalWidth: state => state.finalWidth,
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/ImageGalleryStore.js